import React, { useMemo, useEffect, useRef } from 'react'
import Radio from '../../../common/element/Radio'

const StepComponent = ({
  step = 1,
  selected = {},
  onChange,
  questionsData = [],
  questionsPerStep = 21,
  config
}) => {
  const scrollContainerRef = useRef(null)
  const isTraitsTest = config?.apiEndpoint === 'traitstest'

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0
    }
  }, [step])

  const handleSelect = (questionIdx, value) => {
    const next = { ...(selected || {}) }
    next[questionIdx] = value
    onChange?.(next)
  }

  // Options for Traits Test (5-point scale)
  const traitsOptions = [
    { value: 'Highly Inaccurate', label: 'Highly Inaccurate' },
    { value: 'Moderately Inaccurate', label: 'Moderately Inaccurate' },
    { value: 'Neither Accurate Nor Inaccurate', label: 'Neither Accurate Nor Inaccurate' },
    { value: 'Moderately Accurate', label: 'Moderately Accurate' },
    { value: 'Highly Accurate', label: 'Highly Accurate' }
  ]

  // Options for Inner Needs Test
  const innerNeedsOptions = ['yes', 'partly', 'no']

  if (isTraitsTest) {
    // Traits Test Layout - Single column, full width statements
    return (
      <div className="flex flex-col h-full">
        <div
          ref={scrollContainerRef}
          className="flex-1 overflow-y-auto pr-4 mb-6"
          style={{ maxHeight: 'calc(100vh - 200px)' }}
        >
          <div className="space-y-[10px]">
            {questionsData.map((question, index) => {
              const value = selected?.[question.id] || null
              const questionNumber = (step - 1) * questionsPerStep + index + 1

              return (
                <div
                  key={question.id}
                  className="bg-white rounded-[12px] p-3 md:p-6 lg:p-6 border border-[#FFD7A1]  shadow-sm"
                >
                  <h3 className="font-lato not-italic font-bold text-[18px] md:text-[20px] lg:text-[20px]  leading-[115%] text-black mb-6 text-start">
                    {questionNumber}. {question.question}
                  </h3>
                  <div className="flex justify-start">
                    <div className="inline-flex flex-col md:flex-row lg:flex-row flex-nowrap md:flex-wrap lg:flex-nowrap  rounded-lg overflow-hidden border border-[#D0D5DD]">
                      {traitsOptions.map((option, index) => {
                        const isActive = value === option.value
                        return (
                          <label
                            key={option.value}
                            className={`px-4 py-[10px] font-lato not-italic font-medium text-[14px] leading-[150%] cursor-pointer transition-colors flex items-center gap-2
                        ${isActive
                                ? 'bg-[#FF8E1C] text-white'
                                : 'bg-white text-gray-700 hover:bg-gray-50'
                              }
                            ${index === 0 ? 'rounded-l-md' : ''}
                            ${index === traitsOptions.length - 1 ? 'rounded-r-md' : ''}
                            border-r-0 md:border-r-0 lg:border-r last:border-r-0
                          `}
                          >
                            <Radio
                              name={`question_${question.id}`}
                              value={option.value}
                              checked={isActive}
                              onChange={() => handleSelect(question.id, option.value)}
                            />
                            <span className="font-lato not-italic font-medium text-[14px] leading-[150%]">{option.label}</span>
                          </label>
                        )
                      })}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  // Inner Needs Test Layout - 2 column grid
  return (
    <div className="flex flex-col h-full">
      <div
        ref={scrollContainerRef}
        className="flex-1 overflow-y-auto pr-4 mb-6"
        style={{ maxHeight: 'calc(100vh - 200px)' }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
          {questionsData.map((question) => {
            const value = selected?.[question.id] || null

            return (
              <div
                key={question.id}
                className="bg-white rounded-[12px] p-3 md:p-6 lg:p-6 border border-[#FFD7A1]  shadow-sm"
              >
                <h3 className="font-lato not-italic font-bold text-[18px] md:text-[20px] lg:text-[20px] leading-[115%] text-black mb-6">
                  {question.question}
                </h3>

                <div className="flex justify-center items-center">
                  <div className="inline-flex rounded-lg border border-[#D0D5DD] overflow-hidden">
                    {innerNeedsOptions.map((option, index) => {
                      const isActive = value === option
                      return (
                        <label
                          key={option}
                          className={`px-4 py-[10px] font-lato not-italic font-medium text-[14px] leading-[150%] cursor-pointer transition-colors flex items-center gap-2
                            ${isActive ? 'bg-[#FF8E1C] text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}
                            ${index !== 2 ? 'border-r border-[#D0D5DD]' : ''}
                          `}
                        >
                          <Radio
                            name={`question_${question.id}`}
                            value={option}
                            checked={isActive}
                            onChange={() => handleSelect(question.id, option)}
                          />
                          {option.charAt(0).toUpperCase() + option.slice(1)}
                        </label>
                      )
                    })}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default StepComponent